module.exports = __webpack_public_path__ + "static/media/HaveYourSayBG_Crop_Mob.d5a05fd3.jpg";